import React from "react";
import { Link } from 'react-router';
import { ROUTES } from "../../constants/routes";
import KickerEckLogo from "./KickerEckLogo";

/**
 * Minimal navigation for sub-pages.
 * Only the KickerEck logo, clickable and linking to the home page.
 */
const NavigationMinimal = () => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <Link to={ROUTES.HOME} className="navbar-brand page-scroll">
            <KickerEckLogo />
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default NavigationMinimal;
